var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighBalance = function SvgHighBalance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 141,
    viewBox: "0 0 150 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_611_124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 141
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H145.46C147.393 0.5 148.96 2.067 148.96 4V140.5H0.5V0.5Z",
    fill: "white",
    stroke: "#F3F3F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_611_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.93555 -19.5977L157.492 -63.1199C159.626 -63.6917 161.819 -62.4253 162.391 -60.2915L204.22 95.8158L37.9286 140.373L-4.93555 -19.5977Z",
    fill: "#B6D727"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 64C52.5 46.05 67.05 31.5 85 31.5C102.95 31.5 117.5 46.05 117.5 64C117.5 81.95 102.95 96.5 85 96.5C67.05 96.5 52.5 81.95 52.5 64ZM60 64C60 77.785 71.215 89 85 89C98.785 89 110 77.785 110 64C110 50.215 98.785 39 85 39C71.215 39 60 50.215 60 64ZM87.8 70.375L89.55 46.0275H80.45L82.2 70.375H87.8ZM87.6981 72.6734L80.3499 74.6231L82.2996 81.9713L89.6478 80.0216L87.6981 72.6734Z",
    fill: "#0A9828"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighBalance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "high-balance.835ee1586926022709b929798bdd67d0.svg";